import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  public screenWidth = window.innerWidth;

  constructor() {
    window.addEventListener('resize', () => {
      this.screenWidth = window.innerWidth;
    });
  }

  public getSortIcon(currentSortField: string, currentSortDirection: string, field: string): string {
    if (currentSortField !== field) {
      return 'unfold_more';
    }
    return currentSortDirection === 'asc' ? 'expand_less' : 'expand_more';
  }
}
